/* SENSORIAL sc-card.js — quick add + toast + refresco del cart drawer (Horizon).
   Delegación de eventos: sobrevive a re-renders AJAX (filtros, paginación, recomendaciones). */
(function () {
  'use strict';

  function toast(msg) {
    var el = document.querySelector('.sc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sc-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  // El refresco del carrito lo hace el tema. Aqui solo queda el respaldo de contador por
  // si el puente (sc-cart-bridge.js) no hubiera cargado: antes esta funcion reescribia el
  // innerHTML de <cart-drawer-component> y eso dejaba el cajon sin las lineas del carrito.
  function anadirAlCarrito(lineas, origen) {
    if (window.scCarrito && typeof window.scCarrito.anadir === 'function') {
      return window.scCarrito.anadir(lineas, origen);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lineas })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return r.json();
      })
      .then(function (res) { updateCount(); return res; });
  }

  function updateCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('cart-icon .cart-bubble__text');
        if (bubble) bubble.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sc-add]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-sc-add');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '···';
    anadirAlCarrito([{ id: Number(variantId), quantity: 1 }], 'sc-quick-add')
      .then(function () {
        toast((btn.getAttribute('data-title') || 'Producto') + ' a\u00f1adido al carrito');
        document.dispatchEvent(new CustomEvent('sc:cart:added', { detail: { variantId: variantId } }));
      })
      .catch(function (err) {
        toast(err.message || 'No se pudo a\u00f1adir');
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  /* ---------- FBT: comprados juntamente ---------- */
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function initFbt() {
    var box = document.querySelector('[data-sc-fbt]');
    if (!box || box.dataset.scInit) return;
    box.dataset.scInit = '1';
    var pid = box.dataset.productId;
    var itemsEl = box.querySelector('[data-sc-fbt-items]');
    var totalEl = box.querySelector('[data-sc-fbt-total]');

    function row(variantId, title, price, img, checked, fixed) {
      return (
        '<div class="sc-fbt__row"><label>' +
        '<input type="checkbox" value="' + variantId + '" data-price="' + price + '"' +
        (checked ? ' checked' : '') + (fixed ? ' disabled data-fixed="1"' : '') + '>' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<span class="sc-fbt__t">' + title + '</span></label>' +
        '<span class="sc-fbt__price">' + money(Number(price)) + '</span></div>'
      );
    }

    function recalc() {
      var total = 0;
      box.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
        if (c.checked || c.dataset.fixed) total += Number(c.dataset.price) || 0;
      });
      if (totalEl) totalEl.textContent = money(total);
    }

    // Cuantas sugerencias y si vienen marcadas lo decide el comerciante desde el editor.
    // Por defecto van DESMARCADAS: marcar por el visitante infla el total de salida y le
    // mete en el carrito lo que no ha pedido.
    var maximo = Number(box.dataset.maximo) || 2;
    var premarcados = box.dataset.premarcados === 'true';

    function render(products) {
      var html = row(box.dataset.currentVariant, box.dataset.currentTitle,
        box.dataset.currentPrice, box.dataset.currentImage, true, true);
      // Se descartan los agotados ANTES de recortar: si no, un agotado entre los
      // primeros deja la lista mas corta de lo que ha pedido el comerciante.
      products
        .filter(function (p) {
          var v = p.variants && p.variants[0];
          return v && v.available;
        })
        .slice(0, maximo)
        .forEach(function (p) {
          var v = p.variants[0];
          html += row(v.id, p.title, v.price, p.featured_image ? p.featured_image + '&width=160' : '', premarcados, false);
        });
      itemsEl.innerHTML = html;
      box.hidden = false;
      recalc();
      box.addEventListener('change', recalc);
    }

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + (maximo + 2) + '&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.products && d.products.length) return d.products;
        return fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + (maximo + 2) + '&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (d2) { return d2.products || []; });
      })
      .then(function (products) {
        products = (products || []).filter(function (p) { return String(p.id) !== String(pid); });
        if (products.length) render(products);
      })
      .catch(function () {});

    box.addEventListener('click', function (ev) {
      var addBtn = ev.target.closest('[data-sc-fbt-add]');
      if (!addBtn) return;
      var items = [];
      box.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
        if (c.checked || c.dataset.fixed) items.push({ id: Number(c.value), quantity: 1 });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      anadirAlCarrito(items, 'sc-fbt')
        .then(function () {
          toast(box.dataset.msgAnadido);
        })
        .catch(function (err) { toast(err.message || box.dataset.msgError); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  /* ---------- Selector de plan de suscripción ---------- */
  function getProductForm() {
    return document.querySelector('product-form-component form[action*="/cart/add"], form[action*="/cart/add"]');
  }
  function syncPlan() {
    var picker = document.querySelector('[data-sc-plan-picker]');
    if (!picker) return;
    var checked = picker.querySelector('[data-sc-plan]:checked');
    var form = getProductForm();
    if (!form) return;
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }
    input.value = checked ? checked.value : '';
  }
  function refreshPlanPrices() {
    var picker = document.querySelector('[data-sc-plan-picker]');
    if (!picker) return;
    var map;
    try { map = JSON.parse(picker.getAttribute('data-plan-prices') || '{}'); } catch (e) { return; }
    var form = getProductForm();
    var vid = form && (form.querySelector('input[name="id"], select[name="id"]') || {}).value;
    if (!vid || !map[vid]) return;
    picker.querySelectorAll('[data-sc-plan-price]').forEach(function (el) {
      var planId = el.getAttribute('data-sc-plan-price');
      el.textContent = map[vid][planId] || map[vid].base || el.textContent;
    });
    var baseEl = picker.querySelector('[data-sc-plan-price="base"]');
    if (baseEl) baseEl.textContent = map[vid].base || baseEl.textContent;
  }
  function refreshPricePerKg() {
    var el = document.querySelector('[data-sc-kg]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.getAttribute('data-kg-map') || '{}'); } catch (e) { return; }
    var form = getProductForm();
    var vid = form && (form.querySelector('input[name="id"], select[name="id"]') || {}).value;
    if (!vid) return;
    // Sin entrada en el mapa es el formato de 1 kg: ahi el precio por kilo es el de venta y
    // no se indica (RD 3423/2000). Se oculta en vez de dejar a la vista el del formato anterior.
    if (!map[vid]) { el.hidden = true; return; }
    var val = el.querySelector('[data-kg-val]');
    if (val) val.textContent = map[vid];
    el.hidden = false;
  }
  document.addEventListener('change', function (ev) {
    if (!ev.target.closest) return;
    if (ev.target.closest('[data-sc-plan-picker]')) syncPlan();
    // cambio de variante (picker de Horizon): refrescar precios del plan y el precio/kg tras el morph
    if (ev.target.closest('variant-picker, .variant-picker, [data-testid="variant-picker"]') ||
        ev.target.name === 'id' || (ev.target.type === 'radio' && !ev.target.closest('[data-sc-plan-picker]'))) {
      setTimeout(refreshPlanPrices, 150);
      setTimeout(refreshPlanPrices, 600);
      setTimeout(refreshPricePerKg, 150);
      setTimeout(refreshPricePerKg, 600);
    }
  });
  // Horizon avisa del cambio de variante con shopify:product:select y una promesa que se resuelve
  // cuando ya ha llegado la ficha nueva. Los temporizadores de arriba fallan con red lenta (leen el
  // id de la variante anterior), y aquí eso podía ocultar el precio por kilo obligatorio del 250 g.
  document.addEventListener('shopify:product:select', function (ev) {
    if (!ev.promise || typeof ev.promise.then !== 'function') return;
    ev.promise.then(function () { setTimeout(function () { refreshPricePerKg(); refreshPlanPrices(); }, 50); }, function () {});
  }, true);
  function initPlan() { syncPlan(); refreshPlanPrices(); refreshPricePerKg(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFbt(); initPlan(); });
  } else {
    initFbt();
    initPlan();
  }
})();
